import type { ZodType } from "zod";

export const useSafeSearchParams = <T>(schema: ZodType<T>): T => {
  const searchParams = new URLSearchParams(window.location.search);
  return schema.parse(Object.fromEntries(searchParams));
};
